import React from 'react';
import MetricCard from './MetricCard';
import { SkeletonMetricCard } from '../../util/skeleton/Skeleton';

const DashboardMetrics = ({ userMetrics }) => {
  const isLoading = !userMetrics;

  const formatNumber = (n) => Number(n ?? 0).toLocaleString();
  const formatPercent = (n) => {
    const v = Number(n ?? 0);
    return `${Number.isInteger(v) ? v.toFixed(0) : v.toFixed(1)}%`;
  };

  if (isLoading) {
    return (
      <div className="row row-sm">
        <div className="col-md-12"><SkeletonMetricCard /></div>
        <div className="col-md-12"><SkeletonMetricCard /></div>
        <div className="col-md-12"><SkeletonMetricCard /></div>
      </div>
    );
  }

  const { totalUsers = 0, activeSessions = 0, monthlyGrowth = 0 } = userMetrics || {};

  return (
    <div className="row row-sm">
      <div className="col-md-12">
        <MetricCard
          icon="fe fe-smartphone"
          iconColor="text-info"
          iconBg="bg-info-transparent"
          label="Online Devices"
          value={formatNumber(totalUsers)}
        />
      </div>

      <div className="col-md-12">
        <MetricCard
          icon="fe fe-wifi"
          iconColor="text-success"
          iconBg="bg-success-transparent"
          label="Active Router Sessions"
          value={formatNumber(activeSessions)}
        />
      </div>

      <div className="col-md-12">
        <MetricCard
          icon="fe fe-trending-up"
          iconColor="text-warning"
          iconBg="bg-warning-transparent"
          label="Monthly Growth"
          value={formatPercent(monthlyGrowth)}
        />
      </div>
    </div>
  );
};

export default DashboardMetrics;
